import { render, staticRenderFns } from "./search-good.component.vue?vue&type=template&id=f108f530&"
import script from "./search-good.component.vue?vue&type=script&lang=ts&"
export * from "./search-good.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports